import React from "react";
import { Route, Routes } from "react-router-dom";
import Selfie from "../components/Selfie/Selfie";
import { containerUrl, dashboardUrl } from "../components/utils/constants";
import RegLayout from "../components/Registration/Layout/Layout";
import VideoVerification from "../components/VideoVerification/VideoVerification";
import SmsLinksLayout from "../components/SmsLinksLayout/SmsLinksLayout";
import InstanHelp from "../components/InstantHelp/InstantHelp";

const SmsRoutes = () => (
  <Routes>
    <Route
      path={containerUrl.selfie}
      element={
        <InstanHelp panPageFlag={false}>
          <RegLayout skipOption={true}>
            <SmsLinksLayout >
              <Selfie />
            </SmsLinksLayout>
          </RegLayout>
        </InstanHelp>
      }
    />
    <Route
      path={"/ipvLink"}
      element={
        <InstanHelp panPageFlag={false}>
          <RegLayout skipOption={true}>
            <SmsLinksLayout >
              <VideoVerification />
            </SmsLinksLayout>
          </RegLayout>
        </InstanHelp>
      }
    />
  </Routes>
);

export default SmsRoutes;
